export const updateUser = /* GraphQL */ `
  mutation UpdateUser($id: ID!, $updatedAt: String!, $input: UserUpdate!) {
    updateUser(id: $id, updatedAt: $updatedAt, input: $input) {
      id
      createdAt
      updatedAt
      cognitoUserId
    }
  }
`;

export const adminCreateCognitoUser = /* GraphQL */ `
  mutation AdminCreateCognitoUser(
    $phoneNumber: String!
    $email: String!
    $password: String
  ) {
    adminCreateCognitoUser(
      phoneNumber: $phoneNumber
      email: $email
      password: $password
    ) {
      username
      email
      status
      __typename
    }
  }
`;
